import * as styles  from "./styles.module.scss";
import { useLanguage } from '../../../../../../Contexts/LanguageContext';
import strings from "../../../../../../strings";

export const LanguageSelection = ({
    guide,
    language,
    setLanguage,
}) => {
    const { language: appLanguage } = useLanguage();

    return (
        <div className={styles.container}>
            <select 
                className={styles.select} 
                aria-label={strings.AUDIOGUIDE_LANGUAGE_ARIA_LABEL[appLanguage || 'en'] ?? 'Choose language'}
                onChange={(event) => setLanguage(event.target.value)} value={language?.code}
            >
                {guide.languages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                        {lang.name}
                    </option>
                ))}
            </select>
        </div>
    );
};
